import { PasswordsGenerator } from '@zaoblako/shared/common/classes/passwords.generator';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UserPasswordService {

  public generatePassword(): string {
    return PasswordsGenerator.getInstance().generatePassword();
  }
}
